import uniqid from 'uniqid';

export function createUniqid(type) {
  return type ? `${type}-${uniqid()}` : uniqid();
}
